import { KeycloakConfig } from '@unitedtraders/keycloak';
import { Config as ApiSDKConfig } from '@utex/base-api-sdk';

export interface AppConfig {
  keycloak: KeycloakConfig;
  utcomGateway: ApiSDKConfig;
  graphqlGateway: { url: string };
}

export interface Handlers {
  openExchangeModal: () => void;
}
